<template>
  <div>
    <PCNavbar selectIndex="19"/>
    <MobileNavBar :currentActive="18" />
    <complianceRiskCategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import complianceRiskCategory from '@/components/service_compliance_risk_category-8/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    complianceRiskCategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>